import React, { useState, useEffect, useRef } from 'react';
import './approve.css';
import { DrugExceptionsClient } from '../../../client/drug-exceptions-client';
import { DrugExceptionResponse, DrugExceptionStatus,  RelationshipType } from '../../../model/Reformulary';
import { RadioGroup, FormControlLabel, Radio, TextField } from '@mui/material';
import {useNavigate} from "react-router-dom";
import FormatDateLocale from '../../../util/DateUtil';
interface HandleError {
    handleError: Function;
}
export default function AssessorApprove(props: HandleError) {
    const userId = JSON.parse(sessionStorage.getItem('userId') || '');
    const selectedDrugException: DrugExceptionResponse = JSON.parse(sessionStorage.getItem('selectedDrugException') || '');
    const drugExceptionsClient = new DrugExceptionsClient();
    const history = useNavigate();
    const [status, setStatus] = useState<string>(DrugExceptionStatus[DrugExceptionStatus.APPROVED]);
    const [comment, setComment] = useState<string>(selectedDrugException.comment);
    const [documents, setDocuments] = useState<Blob[]>([]);
    const submitted = selectedDrugException.drugExceptionStatus !== DrugExceptionStatus[DrugExceptionStatus.UNDER_REVIEW];
    const isDependant = (selectedDrugException.claimant?.relationshipType || '') === RelationshipType[RelationshipType.DEPENDANT];
    console.log("===== Drug Exception Status Debug Info =====");
console.log("selectedDrugException:", selectedDrugException);
console.log("selectedDrugException.drugExceptionStatus:", selectedDrugException?.drugExceptionStatus);
console.log("DrugExceptionStatus Enum:", DrugExceptionStatus);
console.log("DrugExceptionStatus.UNDER_REVIEW:", DrugExceptionStatus.UNDER_REVIEW, "=>", DrugExceptionStatus[DrugExceptionStatus.UNDER_REVIEW]);
console.log("DrugExceptionStatus.ASSESSED_APPROVED:", DrugExceptionStatus.ASSESSED_APPROVED, "=>", DrugExceptionStatus[DrugExceptionStatus.ASSESSED_APPROVED]);
console.log("DrugExceptionStatus.ASSESSED_NOT_APPROVED:", DrugExceptionStatus.ASSESSED_NOT_APPROVED, "=>", DrugExceptionStatus[DrugExceptionStatus.ASSESSED_NOT_APPROVED]);
console.log("status:", status);
console.log("submitted:", submitted);
console.log("handleStatusChange:", handleStatusChange);
console.log("===== End Debug Info =====");

    async function fetchData() {
        if (userId) {
            const token = userId.authToken;
            const id = userId.id;
            if (token && id) {
                const documentIdResponse = await drugExceptionsClient.api.get(`/drugexceptions/${selectedDrugException.id}/documents`,{
                    headers: {
                        Authorization: `Bearer ${token}`
                    },
                });

                const documentIds: string[] = documentIdResponse.data;

                documentIds.map(async id => {
                    const documentResponse = await drugExceptionsClient.api.get(`/drugexceptions/${selectedDrugException.id}/document/${id}`,{
                        headers: {
                            Authorization: `Bearer ${token}`
                        },
                        responseType: 'blob'
                    });

                    setDocuments(oldDocuments => [...oldDocuments, documentResponse.data]);

                });
            }
        }
    }

    const handleStatusChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        setStatus((event.target as HTMLInputElement).value);
    };

    const handleCommentChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        setComment((event.target as HTMLInputElement).value);
    };

    const handleSubmit = async () => {
        if (userId) {
            const token = userId.authToken;
            const id = userId.id;
            if (token && id) {
                const request = [
                    {
                        op: 'replace',
                        path: '/drugExceptionStatus',
                        value: status
                    },
                    {
                        op: 'replace',
                        path: '/comment',
                        value: comment
                    }
                ];

                const response = await drugExceptionsClient.api.patch(`/drugexceptions/${selectedDrugException.id}`, request, {
                    headers: {
                        Authorization: `Bearer ${token}`
                    }
                });
            }
        }
        history('/assessor/dashboard');
    };

    useEffect(() => {
        fetchData();
    }, []);

    return (
        <div className="assessor-approve-container">
            <h1>CASE #{selectedDrugException.id}</h1>
            <div className='row'>
                <div className="column">
                    <div className='claimant-details'>
                        <div className='secondary-header'>Claimant Details</div>
                        <div className='name'>{selectedDrugException.claimant?.firstName} {selectedDrugException.claimant?.lastName} {isDependant ? <span>(DEPENDENT)</span> : <></>} </div>
                        <div className='detail-group'>
                            <div className='detail-label'>Gender:</div>
                            <div className='detail-info'>{selectedDrugException.claimant?.gender}</div>
                        </div>
                        <div className='detail-group'>
                            <div className='detail-label'>DOB:</div>
                            <div className='detail-info'>{selectedDrugException.claimant?.dateOfBirth ? FormatDateLocale(new Date(selectedDrugException.claimant?.dateOfBirth)): "--"}</div>
                        </div>
                        {
                            selectedDrugException.claimant?.identity
                            ? <div><div className='detail-group'>
                                <div className='detail-label'>Email:</div>
                                <div className='detail-info'>{selectedDrugException.claimant?.identity.email}</div>
                            </div>
                            <div className='detail-group'>
                                <div className='detail-label'>Phone:</div>
                                <div className='detail-info'>{selectedDrugException.claimant?.identity.phoneNumber}</div>
                            </div></div> : <></>
                        }
                    </div>
                    <div className='plan-member-details'>
                        <div className='secondary-header'>Plan Member Details</div>
                        <div className='name'>{selectedDrugException.claimant?.memberFirstName} {selectedDrugException.claimant?.memberLastName}</div>
                        <div className='detail-group'>
                            <div className='detail-label'>Policy #:</div>
                            <div className='detail-info'>{selectedDrugException.claimant?.policyNumber}</div>
                        </div>
                        <div className='detail-group'>
                            <div className='detail-label'>Certificate #:</div>
                            <div className='detail-info'>{selectedDrugException.claimant?.certificateNumber}</div>
                        </div>
                    </div>
                    <div className='submit-assessment'>
                        <div className='secondary-header'>Submit Assessment</div>
                        <RadioGroup
                            aria-label="gender"
                            name="gender1"
                            value={selectedDrugException.drugExceptionStatus === DrugExceptionStatus[DrugExceptionStatus.UNDER_REVIEW] ? status : selectedDrugException.drugExceptionStatus}
                            onChange={handleStatusChange}
                        >
                            <FormControlLabel disabled={submitted} className='status-radio' value={DrugExceptionStatus[DrugExceptionStatus.ASSESSED_APPROVED]} control={<Radio />} label="Approved" />
                            <FormControlLabel disabled={submitted} className='status-radio' value={DrugExceptionStatus[DrugExceptionStatus.ASSESSED_NOT_APPROVED]} control={<Radio />} label="Not Approved" />
                        </RadioGroup>
                        <TextField
                            id="comment-input"
                            label="Give a reason"
                            multiline
                            fullWidth
                            rows={4}
                            value={comment}
                            onChange={handleCommentChange}
                            variant="filled"
                            disabled={submitted}/>
                        <button disabled={submitted} className="mdc-button mdc-button--raised mdc-ripple-upgrade button-shaped" onClick={handleSubmit}>
                            <div className="mdc-button__ripple"></div>
                            <span className="mdc-button__label">Submit</span>
                        </button>
                    </div>
                </div>
                <div className="column">
                    <div className='secondary-header'>Submitted Form</div>
                    {documents.map((document, index) => {
                        const documentUrl = URL.createObjectURL(document);

                        return document.type === 'image/jpeg' ? (
                            <img src={documentUrl} key={index}/>
                        ) : (
                            <a href={documentUrl} key={index} download>Open pdf form</a>
                        );
                    })}
                </div>
            </div>
        </div>
    );

}